import { useState } from 'react'
import Modal from '../../../../../components/modal/Modal'
import { Icon } from '@iconify/react'
import { post } from '../../../../../utils/Api'
import { useGlobalContext } from '../../../../../utils/Context'
import FormLoader from '../../../../../components/loader/FormLoader'

function EditConfig({ setShowCreate, fetchRates, selectedZoneData }: any) {
  const { notify } = useGlobalContext()
  const [loading, setLoading] = useState(false)

  const createRate = async (data: any) => {
    const emptyFields = []
    if (!data.value) emptyFields.push('value')

    if (emptyFields.length > 0) {
      notify(
        'warn',
        `The following fields are required: ${emptyFields.join(', ')}`,
      )
      return
    }

    const inputData = {
      key: selectedZoneData.key || data.key,
      value: Number(data.value),
      description: data.description || '',
    }
    setLoading(true)
    post(`super-admin-services`, inputData, null)
      .then((result: any) => {
        if (result.status >= 200 && result.status <= 201) {
          notify('success', result.message)
          setShowCreate(false)
          fetchRates(1, 10)
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <Modal>
      <div className='left-modal'>
        <div className='modal-top flex justify-between items-center'>
          <h2>
            {selectedZoneData
              ? 'Edit Service Configuration'
              : 'Create Service Configuration'}
          </h2>
          <div className='close flex items-center justify-center'>
            <Icon icon='line-md:close' onClick={() => setShowCreate(false)} />
          </div>
        </div>
        <form
          className='form'
          onSubmit={(e) => {
            e.preventDefault()
            const formData = new FormData(e.target as HTMLFormElement)
            const data = Object.fromEntries(formData.entries())
            createRate(data)
          }}
        >
          {/* <div className='input-card'>
            <p>Key</p>
            <input
              type='text'
              name='key'
              required
              defaultValue={selectedZoneData?.key}
            />
          </div> */}
          <div className='input-card'>
            <p>Value</p>
            <input
              type='number'
              name='value'
              required
              defaultValue={selectedZoneData?.value}
            />
          </div>
          <div className='input-card'>
            <p>Description</p>
            <input
              type='text'
              name='description'
              defaultValue={selectedZoneData?.description}
            />
          </div>
          <div className='input-card'>
            <br />
            {loading ? (
              <FormLoader position='center' />
            ) : (
              <button type='submit'>
                {selectedZoneData ? 'Save' : 'Create '}
              </button>
            )}
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default EditConfig
